export const predefinedColors = {
  slate: {
    textColor: 'text-slate-600',
    darkTextColor: 'dark:text-slate-400',
    ringColor: 'ring-slate-500/10 dark:ring-slate-400/20',
    borderColor: 'border-slate-500/10 dark:border-slate-400/20',
    borderColorWithoutOpacity: 'border-slate-500 dark:border-slate-400',
    backgroundColor: 'bg-slate-50 dark:bg-slate-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-slate-500/20 dark:hover:bg-slate-400/20 ui-active:bg-slate-500/20 dark:ui-active:bg-slate-400/20',
    removeButtonStrokeColor: 'stroke-slate-600/50 dark:stroke-slate-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-slate-600/75 dark:group-hover:stroke-slate-300',
    colorPickerBackground: 'bg-slate-500',
    colorPickerRing: 'ring-slate-500',
    hoverRingColor: 'hover:ring-slate-300 dark:hover:ring-slate-600',
  },
  gray: {
    textColor: 'text-gray-600',
    darkTextColor: 'dark:text-gray-400',
    ringColor: 'ring-gray-500/10 dark:ring-gray-400/20',
    borderColor: 'border-gray-500/10 dark:border-gray-400/20',
    borderColorWithoutOpacity: 'border-gray-500 dark:border-gray-400',
    backgroundColor: 'bg-gray-50 dark:bg-gray-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-gray-500/20 dark:hover:bg-gray-400/20 ui-active:bg-gray-500/20 dark:ui-active:bg-gray-400/20',
    removeButtonStrokeColor: 'stroke-gray-600/50 dark:stroke-gray-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-gray-600/75 dark:group-hover:stroke-gray-300',
    colorPickerBackground: 'bg-gray-500',
    colorPickerRing: 'ring-gray-500',
    hoverRingColor: 'hover:ring-gray-300 dark:hover:ring-gray-600',
  },
  zinc: {
    textColor: 'text-zinc-600',
    darkTextColor: 'dark:text-zinc-400',
    ringColor: 'ring-zinc-500/10 dark:ring-zinc-400/20',
    borderColor: 'border-zinc-500/10 dark:border-zinc-400/20',
    borderColorWithoutOpacity: 'border-zinc-500 dark:border-zinc-400',
    backgroundColor: 'bg-zinc-50 dark:bg-zinc-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-zinc-500/20 dark:hover:bg-zinc-400/20 ui-active:bg-zinc-500/20 dark:ui-active:bg-zinc-400/20',
    removeButtonStrokeColor: 'stroke-zinc-600/50 dark:stroke-zinc-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-zinc-600/75 dark:group-hover:stroke-zinc-300',
    colorPickerBackground: 'bg-zinc-500',
    colorPickerRing: 'ring-zinc-500',
    hoverRingColor: 'hover:ring-zinc-300 dark:hover:ring-zinc-600',
  },
  neutral: {
    textColor: 'text-neutral-600',
    darkTextColor: 'dark:text-neutral-400',
    ringColor: 'ring-neutral-500/10 dark:ring-neutral-400/20',
    borderColor: 'border-neutral-500/10 dark:border-neutral-400/20',
    borderColorWithoutOpacity: 'border-neutral-500 dark:border-neutral-400',
    backgroundColor: 'bg-neutral-50 dark:bg-neutral-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-neutral-500/20 dark:hover:bg-neutral-400/20 ui-active:bg-neutral-500/20 dark:ui-active:bg-neutral-400/20',
    removeButtonStrokeColor: 'stroke-neutral-600/50 dark:stroke-neutral-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-neutral-600/75 dark:group-hover:stroke-neutral-300',
    colorPickerBackground: 'bg-neutral-500',
    colorPickerRing: 'ring-neutral-500',
    hoverRingColor: 'hover:ring-neutral-300 dark:hover:ring-neutral-600',
  },
  stone: {
    textColor: 'text-stone-600',
    darkTextColor: 'dark:text-stone-400',
    ringColor: 'ring-stone-500/10 dark:ring-stone-400/20',
    borderColor: 'border-stone-500/10 dark:border-stone-400/20',
    borderColorWithoutOpacity: 'border-stone-500 dark:border-stone-400',
    backgroundColor: 'bg-stone-50 dark:bg-stone-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-stone-500/20 dark:hover:bg-stone-400/20 ui-active:bg-stone-500/20 dark:ui-active:bg-stone-400/20',
    removeButtonStrokeColor: 'stroke-stone-600/50 dark:stroke-stone-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-stone-600/75 dark:group-hover:stroke-stone-300',
    colorPickerBackground: 'bg-stone-500',
    colorPickerRing: 'ring-stone-500',
    hoverRingColor: 'hover:ring-stone-300 dark:hover:ring-stone-600',
  },
  red: {
    textColor: 'text-red-700',
    darkTextColor: 'dark:text-red-400',
    ringColor: 'ring-red-600/10 dark:ring-red-400/20',
    borderColor: 'border-red-600/10 dark:border-red-400/20',
    borderColorWithoutOpacity: 'border-red-600 dark:border-red-400',
    backgroundColor: 'bg-red-50 dark:bg-red-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-red-600/20 dark:hover:bg-red-400/20 ui-active:bg-red-600/20 dark:ui-active:bg-red-400/20',
    removeButtonStrokeColor: 'stroke-red-600/50 dark:stroke-red-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-red-600/75 dark:group-hover:stroke-red-300',
    colorPickerBackground: 'bg-red-500',
    colorPickerRing: 'ring-red-500',
    hoverRingColor: 'hover:ring-red-300 dark:hover:ring-red-600',
  },
  orange: {
    textColor: 'text-orange-700',
    darkTextColor: 'dark:text-orange-400',
    ringColor: 'ring-orange-600/10 dark:ring-orange-400/20',
    borderColor: 'border-orange-600/10 dark:border-orange-400/20',
    borderColorWithoutOpacity: 'border-orange-600 dark:border-orange-400',
    backgroundColor: 'bg-orange-50 dark:bg-orange-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-orange-600/20 dark:hover:bg-orange-400/20 ui-active:bg-orange-600/20 dark:ui-active:bg-orange-400/20',
    removeButtonStrokeColor: 'stroke-orange-600/50 dark:stroke-orange-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-orange-600/75 dark:group-hover:stroke-orange-300',
    colorPickerBackground: 'bg-orange-500',
    colorPickerRing: 'ring-orange-500',
    hoverRingColor: 'hover:ring-orange-300 dark:hover:ring-orange-600',
  },
  amber: {
    textColor: 'text-amber-700',
    darkTextColor: 'dark:text-amber-400',
    ringColor: 'ring-amber-600/10 dark:ring-amber-400/20',
    borderColor: 'border-amber-600/10 dark:border-amber-400/20',
    borderColorWithoutOpacity: 'border-amber-600 dark:border-amber-400',
    backgroundColor: 'bg-amber-50 dark:bg-amber-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-amber-600/20 dark:hover:bg-amber-400/20 ui-active:bg-amber-600/20 dark:ui-active:bg-amber-400/20',
    removeButtonStrokeColor: 'stroke-amber-600/50 dark:stroke-amber-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-amber-600/75 dark:group-hover:stroke-amber-300',
    colorPickerBackground: 'bg-amber-500',
    colorPickerRing: 'ring-amber-500',
    hoverRingColor: 'hover:ring-amber-300 dark:hover:ring-amber-600',
  },
  yellow: {
    textColor: 'text-yellow-700',
    darkTextColor: 'dark:text-yellow-400',
    ringColor: 'ring-yellow-600/10 dark:ring-yellow-400/20',
    borderColor: 'border-yellow-600/10 dark:border-yellow-400/20',
    borderColorWithoutOpacity: 'border-yellow-600 dark:border-yellow-400',
    backgroundColor: 'bg-yellow-50 dark:bg-yellow-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-yellow-600/20 dark:hover:bg-yellow-400/20 ui-active:bg-yellow-600/20 dark:ui-active:bg-yellow-400/20',
    removeButtonStrokeColor: 'stroke-yellow-600/50 dark:stroke-yellow-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-yellow-600/75 dark:group-hover:stroke-yellow-300',
    colorPickerBackground: 'bg-yellow-500',
    colorPickerRing: 'ring-yellow-500',
    hoverRingColor: 'hover:ring-yellow-300 dark:hover:ring-yellow-600',
  },
  lime: {
    textColor: 'text-lime-700',
    darkTextColor: 'dark:text-lime-400',
    ringColor: 'ring-lime-600/10 dark:ring-lime-400/20',
    borderColor: 'border-lime-600/10 dark:border-lime-400/20',
    borderColorWithoutOpacity: 'border-lime-600 dark:border-lime-400',
    backgroundColor: 'bg-lime-50 dark:bg-lime-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-lime-600/20 dark:hover:bg-lime-400/20 ui-active:bg-lime-600/20 dark:ui-active:bg-lime-400/20',
    removeButtonStrokeColor: 'stroke-lime-600/50 dark:stroke-lime-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-lime-600/75 dark:group-hover:stroke-lime-300',
    colorPickerBackground: 'bg-lime-500',
    colorPickerRing: 'ring-lime-500',
    hoverRingColor: 'hover:ring-lime-300 dark:hover:ring-lime-600',
  },
  green: {
    textColor: 'text-green-700',
    darkTextColor: 'dark:text-green-400',
    ringColor: 'ring-green-600/10 dark:ring-green-400/20',
    borderColor: 'border-green-600/10 dark:border-green-400/20',
    borderColorWithoutOpacity: 'border-green-600 dark:border-green-400',
    backgroundColor: 'bg-green-50 dark:bg-green-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-green-600/20 dark:hover:bg-green-400/20 ui-active:bg-green-600/20 dark:ui-active:bg-green-400/20',
    removeButtonStrokeColor: 'stroke-green-600/50 dark:stroke-green-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-green-600/75 dark:group-hover:stroke-green-300',
    colorPickerBackground: 'bg-green-500',
    colorPickerRing: 'ring-green-500',
    hoverRingColor: 'hover:ring-green-300 dark:hover:ring-green-600',
  },
  emerald: {
    textColor: 'text-emerald-700',
    darkTextColor: 'dark:text-emerald-400',
    ringColor: 'ring-emerald-600/10 dark:ring-emerald-400/20',
    borderColor: 'border-emerald-600/10 dark:border-emerald-400/20',
    borderColorWithoutOpacity: 'border-emerald-600 dark:border-emerald-400',
    backgroundColor: 'bg-emerald-50 dark:bg-emerald-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-emerald-600/20 dark:hover:bg-emerald-400/20 ui-active:bg-emerald-600/20 dark:ui-active:bg-emerald-400/20',
    removeButtonStrokeColor: 'stroke-emerald-600/50 dark:stroke-emerald-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-emerald-600/75 dark:group-hover:stroke-emerald-300',
    colorPickerBackground: 'bg-emerald-500',
    colorPickerRing: 'ring-emerald-500',
    hoverRingColor: 'hover:ring-emerald-300 dark:hover:ring-emerald-600',
  },
  teal: {
    textColor: 'text-teal-700',
    darkTextColor: 'dark:text-teal-400',
    ringColor: 'ring-teal-600/10 dark:ring-teal-400/20',
    borderColor: 'border-teal-600/10 dark:border-teal-400/20',
    borderColorWithoutOpacity: 'border-teal-600 dark:border-teal-400',
    backgroundColor: 'bg-teal-50 dark:bg-teal-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-teal-600/20 dark:hover:bg-teal-400/20 ui-active:bg-teal-600/20 dark:ui-active:bg-teal-400/20',
    removeButtonStrokeColor: 'stroke-teal-600/50 dark:stroke-teal-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-teal-600/75 dark:group-hover:stroke-teal-300',
    colorPickerBackground: 'bg-teal-500',
    colorPickerRing: 'ring-teal-500',
    hoverRingColor: 'hover:ring-teal-300 dark:hover:ring-teal-600',
  },
  cyan: {
    textColor: 'text-cyan-700',
    darkTextColor: 'dark:text-cyan-400',
    ringColor: 'ring-cyan-600/10 dark:ring-cyan-400/20',
    borderColor: 'border-cyan-600/10 dark:border-cyan-400/20',
    borderColorWithoutOpacity: 'border-cyan-600 dark:border-cyan-400',
    backgroundColor: 'bg-cyan-50 dark:bg-cyan-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-cyan-600/20 dark:hover:bg-cyan-400/20 ui-active:bg-cyan-600/20 dark:ui-active:bg-cyan-400/20',
    removeButtonStrokeColor: 'stroke-cyan-600/50 dark:stroke-cyan-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-cyan-600/75 dark:group-hover:stroke-cyan-300',
    colorPickerBackground: 'bg-cyan-500',
    colorPickerRing: 'ring-cyan-500',
    hoverRingColor: 'hover:ring-cyan-300 dark:hover:ring-cyan-600',
  },
  sky: {
    textColor: 'text-sky-700',
    darkTextColor: 'dark:text-sky-400',
    ringColor: 'ring-sky-600/10 dark:ring-sky-400/20',
    borderColor: 'border-sky-600/10 dark:border-sky-400/20',
    borderColorWithoutOpacity: 'border-sky-600 dark:border-sky-400',
    backgroundColor: 'bg-sky-50 dark:bg-sky-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-sky-600/20 dark:hover:bg-sky-400/20 ui-active:bg-sky-600/20 dark:ui-active:bg-sky-400/20',
    removeButtonStrokeColor: 'stroke-sky-600/50 dark:stroke-sky-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-sky-600/75 dark:group-hover:stroke-sky-300',
    colorPickerBackground: 'bg-sky-500',
    colorPickerRing: 'ring-sky-500',
    hoverRingColor: 'hover:ring-sky-300 dark:hover:ring-sky-600',
  },
  blue: {
    textColor: 'text-blue-700',
    darkTextColor: 'dark:text-blue-400',
    ringColor: 'ring-blue-600/10 dark:ring-blue-400/20',
    borderColor: 'border-blue-600/10 dark:border-blue-400/20',
    borderColorWithoutOpacity: 'border-blue-600 dark:border-blue-400',
    backgroundColor: 'bg-blue-50 dark:bg-blue-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-blue-600/20 dark:hover:bg-blue-400/20 ui-active:bg-blue-600/20 dark:ui-active:bg-blue-400/20',
    removeButtonStrokeColor: 'stroke-blue-600/50 dark:stroke-blue-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-blue-600/75 dark:group-hover:stroke-blue-300',
    colorPickerBackground: 'bg-blue-500',
    colorPickerRing: 'ring-blue-500',
    hoverRingColor: 'hover:ring-blue-300 dark:hover:ring-blue-600',
  },
  indigo: {
    textColor: 'text-indigo-700',
    darkTextColor: 'dark:text-indigo-400',
    ringColor: 'ring-indigo-600/10 dark:ring-indigo-400/20',
    borderColor: 'border-indigo-600/10 dark:border-indigo-400/20',
    borderColorWithoutOpacity: 'border-indigo-600 dark:border-indigo-400',
    backgroundColor: 'bg-indigo-50 dark:bg-indigo-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-indigo-600/20 dark:hover:bg-indigo-400/20 ui-active:bg-indigo-600/20 dark:ui-active:bg-indigo-400/20',
    removeButtonStrokeColor: 'stroke-indigo-600/50 dark:stroke-indigo-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-indigo-600/75 dark:group-hover:stroke-indigo-300',
    colorPickerBackground: 'bg-indigo-500',
    colorPickerRing: 'ring-indigo-500',
    hoverRingColor: 'hover:ring-indigo-300 dark:hover:ring-indigo-600',
  },
  violet: {
    textColor: 'text-violet-700',
    darkTextColor: 'dark:text-violet-400',
    ringColor: 'ring-violet-600/10 dark:ring-violet-400/20',
    borderColor: 'border-violet-600/10 dark:border-violet-400/20',
    borderColorWithoutOpacity: 'border-violet-600 dark:border-violet-400',
    backgroundColor: 'bg-violet-50 dark:bg-violet-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-violet-600/20 dark:hover:bg-violet-400/20 ui-active:bg-violet-600/20 dark:ui-active:bg-violet-400/20',
    removeButtonStrokeColor: 'stroke-violet-600/50 dark:stroke-violet-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-violet-600/75 dark:group-hover:stroke-violet-300',
    colorPickerBackground: 'bg-violet-500',
    colorPickerRing: 'ring-violet-500',
    hoverRingColor: 'hover:ring-violet-300 dark:hover:ring-violet-600',
  },
  purple: {
    textColor: 'text-purple-700',
    darkTextColor: 'dark:text-purple-400',
    ringColor: 'ring-purple-600/10 dark:ring-purple-400/20',
    borderColor: 'border-purple-600/10 dark:border-purple-400/20',
    borderColorWithoutOpacity: 'border-purple-600 dark:border-purple-400',
    backgroundColor: 'bg-purple-50 dark:bg-purple-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-purple-600/20 dark:hover:bg-purple-400/20 ui-active:bg-purple-600/20 dark:ui-active:bg-purple-400/20',
    removeButtonStrokeColor: 'stroke-purple-600/50 dark:stroke-purple-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-purple-600/75 dark:group-hover:stroke-purple-300',
    colorPickerBackground: 'bg-purple-500',
    colorPickerRing: 'ring-purple-500',
    hoverRingColor: 'hover:ring-purple-300 dark:hover:ring-purple-600',
  },
  fuchsia: {
    textColor: 'text-fuchsia-700',
    darkTextColor: 'dark:text-fuchsia-400',
    ringColor: 'ring-fuchsia-600/10 dark:ring-fuchsia-400/20',
    borderColor: 'border-fuchsia-600/10 dark:border-fuchsia-400/20',
    borderColorWithoutOpacity: 'border-fuchsia-600 dark:border-fuchsia-400',
    backgroundColor: 'bg-fuchsia-50 dark:bg-fuchsia-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-fuchsia-600/20 dark:hover:bg-fuchsia-400/20 ui-active:bg-fuchsia-600/20 dark:ui-active:bg-fuchsia-400/20',
    removeButtonStrokeColor: 'stroke-fuchsia-600/50 dark:stroke-fuchsia-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-fuchsia-600/75 dark:group-hover:stroke-fuchsia-300',
    colorPickerBackground: 'bg-fuchsia-500',
    colorPickerRing: 'ring-fuchsia-500',
    hoverRingColor: 'hover:ring-fuchsia-300 dark:hover:ring-fuchsia-600',
  },
  pink: {
    textColor: 'text-pink-700',
    darkTextColor: 'dark:text-pink-400',
    ringColor: 'ring-pink-600/10 dark:ring-pink-400/20',
    borderColor: 'border-pink-600/10 dark:border-pink-400/20',
    borderColorWithoutOpacity: 'border-pink-600 dark:border-pink-400',
    backgroundColor: 'bg-pink-50 dark:bg-pink-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-pink-600/20 dark:hover:bg-pink-400/20 ui-active:bg-pink-600/20 dark:ui-active:bg-pink-400/20',
    removeButtonStrokeColor: 'stroke-pink-600/50 dark:stroke-pink-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-pink-600/75 dark:group-hover:stroke-pink-300',
    colorPickerBackground: 'bg-pink-500',
    colorPickerRing: 'ring-pink-500',
    hoverRingColor: 'hover:ring-pink-300 dark:hover:ring-pink-600',
  },
  rose: {
    textColor: 'text-rose-700',
    darkTextColor: 'dark:text-rose-400',
    ringColor: 'ring-rose-600/10 dark:ring-rose-400/20',
    borderColor: 'border-rose-600/10 dark:border-rose-400/20',
    borderColorWithoutOpacity: 'border-rose-600 dark:border-rose-400',
    backgroundColor: 'bg-rose-50 dark:bg-rose-400/10',
    removeButtonBackgroundHoverColor:
      'hover:bg-rose-600/20 dark:hover:bg-rose-400/20 ui-active:bg-rose-600/20 dark:ui-active:bg-rose-400/20',
    removeButtonStrokeColor: 'stroke-rose-600/50 dark:stroke-rose-400',
    removeButtonStrokeHoverColor:
      'group-hover:stroke-rose-600/75 dark:group-hover:stroke-rose-300',
    colorPickerBackground: 'bg-rose-500',
    colorPickerRing: 'ring-rose-500',
    hoverRingColor: 'hover:ring-rose-300 dark:hover:ring-rose-600',
  },
}
